import { Button, Stack } from "@mui/material";
import Image from "src/components/Image";
import useLocales from "src/hooks/useLocales";

// ----------------------------------------------------------------------

export const ButtonList = () => {
	const { allLang, currentLang, onChangeLang, translate } = useLocales();

	const handleOnChangeLang = (newLang: string) => {
		if (newLang !== currentLang.value) {
			onChangeLang(newLang);
			//dispatch(updateUserLanguajeRequestAction(newLang))
		}
	};

	return (
		<Stack flexDirection={"row"} alignItems={"center"} sx={{ mt: 2 }} gap={2}>
			{allLang.map((option) => (
				<Button
					onClick={() => handleOnChangeLang(option.value)}
					key={option.value}
					startIcon={<Image src={option.icon} sx={{ width: 20, height: 14 }} />}
					variant={option.value === currentLang.value ? "contained" : "text"}
					color={option.value === currentLang.value ? "primary" : "inherit"}
				>
					{translate(`languages.${option.label}`)}
				</Button>
			))}
		</Stack>
	);
};

export default ButtonList;
